import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { RecommendationsFormComponent } from '../../recommandations-form/recommandations-form.component';
import { CompareProductListComponent } from 'src/app/customers/compare-product-list/compare-product-list.component';
import { MarketplacePageComponent } from 'src/app/customers/marketplace/marketplace.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { PopUpService } from 'src/app/popupservice.service';
import { NearbyMapComponent } from 'src/app/nearby-map/nearby-map.component';
import { SearchService } from 'src/app/search.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header-search-map',
  templateUrl: './header-search-map.component.html',
  styleUrls: ['./header-search-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderSearchMapComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @ViewChild('keywordContainer') keywordContainer!: ElementRef;

  // Inputs
  @Input() design: string = '';
  arrow: boolean = false;
  item: any = {
    0: {
      items: 2,
    },
  };
  // Output Events
  @Output() onChangeEvent = new EventEmitter<any>();
  @Output() view = new EventEmitter<any>();
  public screenWidth: number;
  public imgUrl = environment.ImageUrl;
  public isLogin: any = 0;
  public maps: any = {
    search: '',
    postalCode: 'All',
    radius: 5,
    products: [],
    productsToCompare: [],
    all: true,
    subCategoriesBasedOnKeyWords: [],
    subcats: [],
    fetchedFaqs: [],
    filter: '',
  };
  public visibleFAQ = [false, false, false, false, false, false, false];
  public showFAQ(i) {
    this.visibleFAQ[i] = !this.visibleFAQ[i];
  }

  public popularKeywords: any = [];
  public memberShopPageSize: number;
  public filterMaps: any = [
    {
      name: 'Affordable',
      value: 'affordable',
      icon: 'fa-solid fa-dollar-sign',
      selected: false,
    },
    {
      name: 'Available now',
      value: 'available',
      icon: 'fa-solid fa-clock',
      selected: false,
    },
    {
      name: 'Promotion',
      value: 'promotion',
      icon: 'fa-solid fa-bolt',
      selected: false,
    },
  ];

  public selectedFilterMap: any = [];
  public clickId(id) {
    this.commonService.clickButton(id);
  }

  /**
   * Constructor
   */
  constructor(
    private modalService: NgbModal,
    private local: LocalServiceService,
    private customerService: CustomerService,
    private auth: AuthServiceService,
    private sharedService: SharedService,
    private changeDetectorRef: ChangeDetectorRef,
    private bottomSheet: MatBottomSheet,
    private commonService: CommonService,
    private popup: PopUpService,
    private searchService: SearchService,
    @Inject('WINDOW') private window: any,
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router
  ) {
    this.isLogin = this.local.getUser()?.id ? 1 : 0;
    if (isPlatformBrowser(this.platformId)) {
      this.screenWidth = this.window.innerWidth;
    }
    this.memberShopPageSize = this.screenWidth < 768 ? 4 : 8;
  }
  public get innerWidth() {
    if (!this.sharedService.isBrowser()) {
      return 0;
    }
    return window.innerWidth;
  }

  ngOnInit(): void {
    this.maps.radius = 'All';
    // this.maps.postalCode = this.local.getPostalCode();
    this.local
      .getUserDetailsObserver()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user?.id) {
          const { postalCode } = user;
          if (postalCode) {
            this.maps.postalCode = postalCode;
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.local.clearTimeout(this.timeout1);
    this.local.clearTimeout(this.timeout2);
    this.destroy$.next();
    this.destroy$.complete();
  }

  public handleFilterMap(filter: any) {
    if (this.selectedFilterMap.includes(filter)) {
      this.selectedFilterMap = this.selectedFilterMap.filter(
        (f) => f !== filter
      );
    } else {
      this.selectedFilterMap.push(filter);
    }
    this.handleFilter();
    this.changeDetectorRef.detectChanges();
  }

  public timeout1: any;
  public get isMobile(): boolean {
    return this.sharedService.isBrowser() && window.innerWidth <= 991;
  }
  openFilterModal(isCategoryOnlySearch = false) {
    //this.local.clearTimeout(this.timeout1);
    // this.modalService.dismissAll();
    // const ref = this.popup.openPopup(NearbyMapComponent, {
    //   forceMode: 'modal',
    //   modalSize: 'lg',
    //   // focusFirst: false
    // }) as NgbModalRef;
    //ref.componentInstance.search(this.maps.search, isCategoryOnlySearch);
    // this.searchService.addInSavedSearch(this.maps.search);
    const searchParams = new URLSearchParams();
    let categorySlug ='';
    const search = this.maps.search
    if (typeof search !== 'object') {
      searchParams.append('search', search);
    } else {
      const slug = search?.name?.split(' ').join('-').toLowerCase();
      if (search?.type == 'cat') {
        categorySlug = 'c-' + slug;
      } else if (search?.type == 'subcat') {
        categorySlug = 's-' + slug;
      } else if (search?.type == 'type') {
        categorySlug = 't-' + slug;
      }
    }
    if (isCategoryOnlySearch) {
      searchParams.append('isCategoryOnlySearch', '1');
    }
    searchParams.append('hideCategory', '1');

    this.router.navigateByUrl(`/map${categorySlug ? '/' + categorySlug : ''}?${searchParams.toString()}`);

    // Disable Auto-Focus Using Modal Options
    // this.timeout1 = setTimeout(() => {
    //   const modalElement = document.querySelector('.modal');
    //   const firstInput = modalElement?.querySelector(
    //     'input, button, select, textarea, a[href]'
    //   );
    //   if (firstInput) {
    //     (firstInput as HTMLElement).blur();
    //   }
    // }, 0);
  }

  openPopupModal(modal: any) {
    this.modalService.dismissAll();
    this.modalService.open(modal, {
      size: 'md',
      windowClass: 'modal-popup',
      // focusFirst: false
    });
  }
  carouselOptions: any = {
    // slidesPerView: 1,
    // spaceBetween: 10,
    pagination: false,
    effect: 'flip',
    grabCursor: true,
  };
  currentIndex = 0;

  public get faqsExist() {
    const faqInfos = this.maps.fetchedFaqs;

    const keys = [
      'questionOne',
      'answerOne',
      'questionTwo',
      'answerTwo',
      'questionThree',
      'answerThree',
      'questionFour',
      'answerFour',
      'questionFive',
      'answerFive',
    ];
    let strOn =
      faqInfos && faqInfos != 'null' && typeof faqInfos == 'string' && faqInfos;

    if (faqInfos && typeof faqInfos == 'object') {
      for (const key of keys) {
        if (faqInfos[key]) {
          return true;
        }
      }
    }
    return strOn;
  }

  titles = [
    'Cherishing Family Moments',
    'Building Strong Bonds',
    'Love and Support',
    'Family Traditions',
    'Growing Together',
    'Unbreakable Ties',
    'Nurturing Generations',
    'A Home Filled with Laughter',
    'Strength in Togetherness',
    'Heartfelt Connections',
  ];

  descriptions = [
    'Every moment spent with family is precious and unforgettable, creating memories to last a lifetime.',
    'Strong bonds create a foundation of trust and understanding that withstands any challenge.',
    'Unconditional love and support keep families united through life’s ups and downs.',
    'Family traditions bring joy, continuity, and a sense of belonging across generations.',
    'Families grow stronger when they learn, laugh, and overcome obstacles together.',
    'No matter the distance, the ties that bind family hearts remain unbreakable.',
    'Passing down values and wisdom nurtures future generations to thrive.',
    'A home filled with laughter is a sanctuary where everyone feels safe and loved.',
    'Togetherness gives strength, creating resilience against life’s challenges.',
    'Heartfelt connections are the threads weaving family stories into a rich tapestry.',
  ];

  popupSlider(event: any) {
    // Pre Fetch data
    this.currentIndex = event.activeIndex;
  }

  private _getPopularKeywords() {
    this.customerService
      .popularMemberShopKeyword()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
        this.popularKeywords = response.body;
      });
  }

  public handleKeywordsValue(value: string) {
    this.maps.search = value;
  }

  private _clickSearch() {
    document.getElementById('btnSearchGmap').click();
  }

  public handleSearch(value: any) {
    this.maps.radius = value;
    this._clickSearch();
  }

  public handleFilter() {
    this.maps.filter = this.selectedFilterMap.map((f) => f.value).join(',');
    console.log(this.maps.filter);
    this._clickSearch();
  }

  @ViewChild('marketplace') marketplacePage: MarketplacePageComponent;
  public viewProduct(product: any) {
    this.marketplacePage.enableMemberShop = true;
    this.marketplacePage.viewProduct(product, false, false);
  }

  public openRecommendationForm() {
    if (!this.local.getUser()) {
      this.commonService.clickButton('loginBtn');
      return;
    }
    // if (this.screenWidth <= 767) {
    //   this.bottomSheet.open(RecommendationsFormComponent, {
    //     panelClass: 'bottom-sheet-1',
    //   });
    // } else {
    //   this.modalService.open(RecommendationsFormComponent);
    // }
    this.popup.openPopup(RecommendationsFormComponent, {
      bottomSheetPanelClass: 'bottom-sheet-1',
    });
  }

  public timeout2: any;
  public async openCompareProductsModal() {
    this.local.clearTimeout(this.timeout2);
    //used to open a modal that is used to comapre the top 5 results from the search

    this.maps.productsToCompare.forEach((pd) => {
      this.productBottomDiscussExperienceTabSettings.push(
        this.getBottomTabInfo(pd)
      );
    });

    this.loadCompareProductsRatings();
    await this.loadOtherImagesOfCompareProducts();
    this.maps.productsToCompare.forEach(
      (prod) => (prod.enableMemberShop = true)
    );

    this.timeout2 = setTimeout(() => {
      const ref = this.modalService.open(CompareProductListComponent, {
        size: 'lg',
        windowClass: 'transparent-window',
        modalDialogClass: 'glass-bg',
        centered: true,
      });
      ref.componentInstance.productsToCompare = this.maps.productsToCompare;
      ref.componentInstance.productBottomDiscussExperienceTabSettings =
        this.productBottomDiscussExperienceTabSettings;
    }, 0);
  }

  public getBottomTabInfo(pd) {
    if (!pd) {
      return [];
    }
    return [
      {
        title: 'Experiences',
        condition: pd?.xpCount > 0,
      },
      {
        title: 'Discuss',
        condition: pd?.forum,
      },
    ];
  }

  productBottomDiscussExperienceTabSettings = [];

  public productSelectedChanged(product, isSelected) {
    let indexOfProduct = this.maps.productsToCompare.indexOf(product);
    if (isSelected) {
      if (indexOfProduct == -1) {
        this.maps.productsToCompare.push(product);
      }
    } else {
      if (indexOfProduct !== -1) {
        this.maps.productsToCompare.splice(indexOfProduct, 1);
      }
    }
  }

  public showMoreKeywords = false;
  public showMoreSubcats = false;
  private loadRatingOn(pd) {
    let ratings = [];

    if (pd && pd['seller_info']) {
      let sellerInfo = pd['seller_info'];

      if (sellerInfo && typeof sellerInfo === 'string') {
        sellerInfo = JSON.parse(sellerInfo);
      } else {
        pd.ratings = [];
      }
      if (
        'googleReviewRating' in sellerInfo &&
        (sellerInfo.googleReviewRating ||
          sellerInfo.googleReviewCount ||
          sellerInfo.googleReviewUrl)
      ) {
        ratings.push({
          icon: 'ggle.png',
          name: 'Google Reviews',
          ratingUrl: sellerInfo.googleReviewUrl,
          rating: sellerInfo.googleReviewRating,
          counts: sellerInfo.googleReviewCount,
        });
      }
      if (
        'fbReviewRating' in sellerInfo &&
        (sellerInfo.fbReviewRating ||
          sellerInfo.fbReviewCount ||
          sellerInfo.fbReviewUrl)
      ) {
        ratings.push({
          icon: 'facebook.png',
          name: 'Facebook Reviews',
          ratingUrl: sellerInfo.fbReviewUrl,
          rating: sellerInfo.fbReviewRating,
          counts: sellerInfo.fbReviewCount,
        });
      }

      if (
        'carousellReviewRating' in sellerInfo &&
        (sellerInfo.carousellReviewRating ||
          sellerInfo.carousellReviewCount ||
          sellerInfo.carousellReviewUrl)
      ) {
        ratings.push({
          icon: 'carousell.png',
          name: 'Carousel Reviews',
          ratingUrl: sellerInfo.carousellReviewUrl,
          rating: sellerInfo.carousellReviewRating,
          counts: sellerInfo.carousellReviewCount,
        });
      }
    }
    ratings = structuredClone(ratings);
    pd.ratings = ratings;
  }

  private loadCompareProductsRatings() {
    for (const pd of this.maps.productsToCompare) {
      this.loadRatingOn(pd);
    }
  }

  private getImageByAccessor(images, accessor) {
    const imageObj = images?.find((o) => o.imageAccessor === accessor);
    return imageObj ? imageObj.image : '';
  }

  private loadOtherImagesOfProduct(productData) {
    productData['foodSpecs'] = productData?.memberShopProductsVariations || [];
    productData['food_image_1'] = this.getImageByAccessor(
      productData.memberShopProductsImages,
      'image1'
    );
    productData['food_image_active'] = productData['food_image_1'];
    productData['food_image_2'] = this.getImageByAccessor(
      productData.memberShopProductsImages,
      'image2'
    );
    productData['food_image_3'] = this.getImageByAccessor(
      productData.memberShopProductsImages,
      'image3'
    );
    productData['food_image_4'] = this.getImageByAccessor(
      productData.memberShopProductsImages,
      'image4'
    );
  }

  private loadOtherImagesOfCompareProducts() {
    return new Promise((res, rej) => {
      for (const prod of this.maps.productsToCompare) {
        this.loadOtherImagesOfProduct(prod);
      }
      res(1);
    });
  }

  paramChange() {
    //console.log('params change', this.maps);
    this.selectedSubCatIds.clear();
    this.selectedTypesId.clear();
    this.maps = structuredClone(this.maps);
    this.maps.products.sort((a, b) => {
      const aGlow = a.glowPoints > 0 && a.glowType === 1 ? 1 : 0;
      const bGlow = b.glowPoints > 0 && b.glowType === 1 ? 1 : 0;
      return bGlow - aGlow;
    });
  }

  @ViewChild('filterPopup')
  public filterPopup: TemplateRef<any>;
  public isSearchFromHomepage = false;

  public openSuggestionText(text) {
    this.searchSuggestions = [];
    this.maps.search = text;
    this.isSearchFromHomepage = true;
    this.openFilterModal(true);
  }
  public removeSearchFromHistory(entry) {
    console.log('removing', { entry });
    this.searchService.removeSearch(entry.name);
    this.searchSuggestions = this.searchSuggestions.filter(
      (search) => search.name != entry.name
    );
  }
  public searchSuggestions = [];
  public historyStartsFromIndex = -1;
  public getSearchSuggestions(event) {
    const isAscii = event.key?.length === 1; //called for backspace and stuff so not reliable

    const term = event.target.value;
    if (term.length + (isAscii ? 1 : 0) < 3) {
      this.searchSuggestions = [];
      return;
    }
    this.auth
      .getSearchSuggestions(term + (isAscii ? event.key : ''))
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.searchSuggestions = (data.body ?? []).slice(0, 4);
          console.log(this.searchSuggestions);
          this.changeDetectorRef.detectChanges();
          this.historyStartsFromIndex = this.searchSuggestions.length;
          this.searchSuggestions = [
            ...this.searchSuggestions,
            ...this.searchService.getMatchedString(
              term + (isAscii ? event.key : '')
            ),
          ];
          this.changeDetectorRef.detectChanges();
          //  console.log(this.searchSuggestions);
        },
        error: console.error,
      });
  }
  public selectedTypesId = new Set<any>();
  public selectedSubCatIds = new Set();

  public toggleSubCatAndSearch(subCat) {
    if (this.selectedSubCatIds.has(subCat.id)) {
      this.selectedSubCatIds.delete(subCat.id);
    } else {
      this.selectedSubCatIds.clear();
      this.selectedSubCatIds.add(subCat.id);
    }

    this.__fetchProductsUsingSelectedSubCats();
  }

  private _tempSubcats = [];
  private _tempTypes = [];

  private __fetchProductsUsingSelectedSubCats() {
    let selectedSubCatsId = Array.from(this.selectedSubCatIds);

    if (selectedSubCatsId.length == 0) {
      this._tempTypes = [...this.maps.subCategoriesBasedOnKeyWords]; //sacve casue it will be overwritten
      this._tempSubcats = [...this.maps.subcats]; //save it cause it will be overwritten
      this._clickSearch();

      return;
    }
    this.customerService
      .getMemberShopProductList({
        categoryId: selectedSubCatsId,
        basedProduct: 'all',
        page: 1,
        orderBy: 'latest',
        limit: 10,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.maps.products = data.body.data.sort((a, b) => {
            const aGlow = a.glowPoints > 0 && a.glowType === 1 ? 1 : 0;
            const bGlow = b.glowPoints > 0 && b.glowType === 1 ? 1 : 0;
            return bGlow - aGlow;
          });
        },
        error: console.error,
      });
  }
  private _fetchProductsUsingSelectedTypes() {
    let selectedTypeIds = Array.from(this.selectedTypesId).map((t) => t.id);
    if (selectedTypeIds.length == 0) {
      this._tempTypes = [...this.maps.subCategoriesBasedOnKeyWords]; //sacve casue it will be overwritten
      this._tempSubcats = [...this.maps.subcats]; //save it cause it will be overwritten
      this._clickSearch();

      // this._clickSearch();
      return;
    }

    this.auth
      .fetchProductsBasedOnTypes({ types: selectedTypeIds })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          this.maps.products = data.data.sort((a, b) => {
            const aGlow = a.glowPoints > 0 && a.glowType === 1 ? 1 : 0;
            const bGlow = b.glowPoints > 0 && b.glowType === 1 ? 1 : 0;
            return bGlow - aGlow;
          });
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  public toggleTypeAndSearch(type) {
    //changed to length 1 now but might return so stil will use sets
    if (this.selectedTypesId.has(type)) {
      this.selectedTypesId.delete(type);
    } else {
      this.selectedTypesId = new Set(
        Array.from(this.selectedTypesId as Set<any>).filter(
          (v: any) => v.type != type.type
        )
      );
      this.selectedTypesId.add(type);
    }

    this._fetchProductsUsingSelectedTypes();
  }
}
